<div class="dialog-container">
    <!-- Dismiss button -->
    @if (data.dismissible) {
        <div class="dismiss-button">
            <button mat-icon-button [matDialogClose]="undefined">
                <mat-icon class="text-secondary">close</mat-icon>
            </button>
        </div>
    }

    <!-- Content -->
    <div class="content">
        <!-- Icon -->
        @if (data.icon.show) {
            <div
                class="icon-container"
                [ngClass]="{
                    'icon-primary': data.icon.color === 'primary',
                    'icon-accent': data.icon.color === 'accent',
                    'icon-warn': data.icon.color === 'warn',
                    'icon-basic': data.icon.color === 'basic',
                    'icon-info': data.icon.color === 'info',
                    'icon-success': data.icon.color === 'success',
                    'icon-warning': data.icon.color === 'warning',
                    'icon-error': data.icon.color === 'error'
                }"
            >
                <mat-icon class="text-current">{{data.icon.name}}</mat-icon>
            </div>
        }

        <div class="text-container">
            <!-- Title -->
            @if (data.title) {
                <div
                    class="title"
                    [innerHTML]="data.title"
                ></div>
            }

            <!-- Message -->
            @if (data.message) {
                <div
                    class="message"
                    [innerHTML]="data.message"
                ></div>
            }
        </div>
    </div>

    <!-- Date Picker -->
    @if (data.showDatePicker) {
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Transaction Date</mat-label>
            <input matInput [matDatepicker]="picker" [(ngModel)]="data.selectedDate" (dateChange)="onDateChange()">
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
    }

    <!-- Amount Display -->
    @if (data.showAmount) {
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Transfer Amount</mat-label>
            <input matInput readonly [value]="'$' + (data.amount | number:'1.2-2')">
        </mat-form-field>
    }

    <!-- Actions -->
    @if (data.actions.confirm.show || data.actions.cancel.show) {
        <div class="dialog-actions">
            <!-- Cancel -->
            @if (data.actions.cancel.show) {
                <button mat-stroked-button class="cancel-btn" [matDialogClose]="'cancelled'">
                    {{ data.actions.cancel.label }}
                </button>
            }

            <!-- Confirm -->
            @if (data.actions.confirm.show) {
                <button
                    mat-flat-button
                    [color]="data.actions.confirm.color"
                    class="confirm-btn"
                    (click)="confirm()"
                >
                    {{ data.actions.confirm.label }}
                </button>
            }
        </div>
    }
</div>
